import store from '@/store'
import network from '@/utils/network'
import { agencyPath, createRequestWithComputedFilters } from '@/utils/api'

/**
 * Soumet un email
 * @returns {Promise<>}
 */
export const postAgencyEmail = async (email) => {
  const slugAgency = store.getters['user/agencySlug']
  const r = await network.post(`agency/${slugAgency}/email`, email)
  return r.data
}

/**
 * Récupérer la liste des emails de l'agence
 * @returns {Promise<>}
 */
export const fetchAgencyEmails = createRequestWithComputedFilters(
  async (params) => {
    const r = await network.post(`${agencyPath()}/fetch/emails`, params)
    return r.data
  },
  {
    orderBy: 'createdAt'
  })

/**
 * Récupérer la liste des évènements liés aux emails de l'agence
 * @returns {Promise<>}
 */
export const fetchAgencyEmailsEvents = createRequestWithComputedFilters(
  async (params) => {
    const r = await network.post(`${agencyPath()}/fetch/emails/events`, params)
    return r.data
  },
  {
    orderBy: 'createdAt'
  })
